export function indexBy(items = [], getKey) {
    return items.reduce((acc, item) => {
        const key = getKey(item);

        if (key !== undefined && key !== null && key !== '') {
            acc[String(key)] = item;
        }

        return acc;
    }, {});
}